<template>
  <div
    :class="
      'bg-dark-20 p-2.5 rounded-md font-medium border' +
      (selected ? ' border-red-500 bg-white' : ' border-white')
    "
  >
    <div class="flex flex-col">
      <div class="flex justify-between mb-1.5">
        <span class="text-sm font-medium text-dark label">{{
          additional.title
        }}</span>
        <span class="price font-semibold text-sm text-dark shrink-0">{{
          formatCurrency(additional.price)
        }}</span>
      </div>
      <div class="flex justify-between items-start">
        <span class="text-2xs text-dark-28 subheading">{{
          additional.subheading
        }}</span>
        <form-switch :checked="selected" v-bind="$attrs" />
      </div>
    </div>
  </div>
</template>
<script>
import FormSwitch from "./forms/FormSwitch.vue";

export default {
  components: {
    FormSwitch,
  },
  props: {
    additional: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
